import { render, staticRenderFns } from "./CartProcess.vue?vue&type=template&id=643d1018&"
import script from "./CartProcess.vue?vue&type=script&lang=js&"
export * from "./CartProcess.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports